"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
var React = require("react");
var Divider_st_css_1 = require("./Divider.st.css");
exports.Divider = function (props) { return (React.createElement("div", { className: Divider_st_css_1.st(Divider_st_css_1.classes.root, props.className), "data-hook": props['data-hook'] })); };
//# sourceMappingURL=Divider.js.map